import { useState } from 'react'
import Header from '../Header'
import Form from '../Form'
import Footer from '../Footer'
import Section from '../Section'
import { RadioList } from '../Input'
import styled from 'styled-components'
import { Step2Container } from '@src/shared/styles/home'
import { Button } from '@favordelivery/tupperware'
import { t, tStr } from '@utils/lang'

const P = styled.p`
  color: var(--themeColorForegroundPrimary);
  margin-bottom: 40px;
`

const SelectMarket = ({ markets, clearMarkets, selectMarket }) => {
  const [market, setMarket] = useState(markets[0].id)

  return (
    <Step2Container>
      <div>
        <Form>
          <Section>
            <Header id="marketListHeader">{t('marketSelectTitle_s')}</Header>
            <P>{t('marketSelectBody_s')}</P>
            <RadioList
              options={markets.map(m => ({
                value: m.id,
                label: tStr('marketOption_s', { name: m.name, distance: parseInt(m.distance, 10) })
              }))}
              name="markets"
              labelId="marketListHeader"
              value={market}
              onChange={option => setMarket(option.value)}
            />
          </Section>
          <Footer>
            <Button displayType="secondary" onClick={clearMarkets}>
              {t('marketNeverMind_s')}
            </Button>
            <Button onClick={() => selectMarket(markets.find(m => m.id === market))} disabled={!market}>
              {t('marketNext_s')}
            </Button>
          </Footer>
        </Form>
      </div>
    </Step2Container>
  )
}

export default SelectMarket
